// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"6f3a1a47","461":"186bed70","534":"82b756da","929":"1df613b6"}[chunkId] + ".chunk.js";
};